export const SELECTORS = {
  REVIEWS: 'js-reviews',
  FILTER: 'js-reviews-filter',
  REVIEWS_RATING_STARS: 'js-reviews-rating-stars',
  ZERO_STATE: 'js-reviews-zero-state',
  AVERAGE_RATING: 'js-reviews-average-rating',
  AVERAGE_RATING_COUNT: 'js-reviews-average-rating-count',
  ZERO_AVERAGE_RATING: 'js-reviews-zero-average-rating',
  TOTAL_COUNT: 'js-reviews-total-count'
};
